module.exports = __webpack_public_path__ + "img/bespoke70_07.e8d18396.jpg";